module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"name":"Name","client_id":"Afflo ID","ctr_id":"CTR ID","age":"Age","sex":"Sex","abo":"ABO"},"fr":{"name":"Nom","client_id":"No Afflo","ctr_id":"No CTR","age":"Âge","sex":"Sexe","abo":"ABO"},"en_tgln":{"client_id":"TGLN ID"},"fr_tgln":{"client_id":"No TGLN"},"en_tq":{"client_id":"TQ Number"},"fr_tq":{"client_id":"No TQ"}}')
  delete Component.options._Ctor
}
